module.exports = __webpack_public_path__ + "21673925c253a75f2cc24f4fce12a3f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00003II8.png
// module id = 1677
// module chunks = 0